class MobileNavigation {
    sidebar = document.querySelector('[data-mobile-navigation-sidebar]');

    openButton = document.querySelector('[data-mobile-navigation-open]');

    closeButton = document.querySelector('[data-mobile-navigation-close]');

    constructor() {
        this.openButton.addEventListener('click', event => {
            event.stopPropagation();

            this.open();
        });

        this.closeButton.addEventListener('click', event => {
            event.stopPropagation();

            this.close();
        });
    }

    handleClickOutside = event => {
        if (this.sidebar.contains(event.target) === false) {
            this.close();
        }
    };

    handleEscape = event => {
        if (event.key === 'Escape') {
            this.close();
        }
    };

    open = () => {
        const event = () => {
            this.sidebar.classList.remove('open-animation');
            this.sidebar.removeEventListener('animationend', event);
        };

        this.sidebar.addEventListener('animationend', event);

        this.sidebar.classList.add('is-open');
        this.sidebar.classList.add('open-animation');

        window.addEventListener('mousedown', this.handleClickOutside);
        window.addEventListener('touchstart', this.handleClickOutside);
        window.addEventListener('keydown', this.handleEscape);
    };

    close = () => {
        const event = () => {
            this.sidebar.classList.remove('is-open');
            this.sidebar.classList.remove('close-animation');

            this.sidebar.removeEventListener('animationend', event);
        };

        this.sidebar.addEventListener('animationend', event);
        this.sidebar.classList.add('close-animation');

        window.removeEventListener('mousedown', this.handleClickOutside);
        window.removeEventListener('touchstart', this.handleClickOutside);
        window.removeEventListener('keydown', this.handleEscape);
    };
}

/* eslint-disable-next-line no-new */
new MobileNavigation();
